<s2a-sidenav
[isAuthenticated]="isAuthenticated"
(appBellClicked)="toggleAppBellHandler($event)"
>
  <router-outlet ngProjectAs="sidenav-router"></router-outlet>
  <s2a-app-bell [appBellOpened]="appBellOpened" ngProjectAs="notification" (appBellClosed)="toggleAppBellHandler(true)">
    <s2a-notification-timeline></s2a-notification-timeline>
  </s2a-app-bell>
</s2a-sidenav>
